export const lang = {
  //菜单
  menu: {
    Home: "Dashboard",
    device: "Device Management",
    devicelist: "Device List",
    groupinglist: "Group List",
    unusuallist: "Abnormal List",
    resource: "Config Management",
    configuration: "Config List",
    configurationlist: "Config Setting",
    firmware: "Batch Config",
    alarmMsg: "Alarm Management",
    historywarn: "Alarm History",
    warnconfiguration: "Alarm Configuration",
    currenttimewarn: "Real Time Alarm",
    diagnosemessage: "Diagnostic",
    graphs: "Report Management",
    onlinerate: "Online Ratio",
    flowstatistics: "Traffic Statistics",
    signalstatistics: "Signal Statistics",
    Softwareversion: "Software Version",
    task: "Software Management",
    softwarepackage: "Firmware Management",
    upgrade: "Software Task",
    system: "System Management",
    Authoritymanagement: "Security Management",
    customermanagement: "Customer Management",
    usercontrol: "User Management",
    parametermanagement: "Parameter",
    RemoteService: "Remote Service",
    AlarmContact: "Alarm Contact",
    North: "North",
    PrinterDriver: "PrinterDriver Management",
    HangingDevice: "Printer List",
  },
  //表格组件
  TableComponent: {
    operating: "Operating",
    edit: "Edit",
    delete: "Delete",
    loading: "Loading...",
    empty: "Empty",
    loadingFail: "Data loading failed",
    serialNumber: "Serial Number",
  },
  //登录页
  login: {
    LoginTitle: "IoT Cloud Platform",
    userDisplay: "User Login",
    user_isloggedin: "Please enter username or email",
    Password_By_Supervisor: "Password",
    http_login: "Login",
    viewport: "User name or password error, please check and re-enter",
    password_short: 'Password length cannot be less than 6 digits'
  },
  //axios拦截提示
  http: {
    prompt: "Prompt",
    Text: "Login status has expired. Please login again!",
    Buttom: "ReLogin",
  },
  //路由
  router: {
    Dashboard: "Dashboard",
    Index: "Dashboard",
    Login: "Internet of things cloud platform login",
    Gateone: "Gateone",
    Device: "Device Management",
    Particulars: "Device Details",
    DeviceList: "Device List",
    CloudMonitorDeviceList: "Device List",
    GroupingList: "Group List",
    Unusuallist: "Abnormal List",
    Resource: "Config Management",
    Configuration: "Config List",
    Configurationlist: "Config Setting",
    Firmware: "Batch Config",
    AlarmMsg: "Alarm Management",
    Historywarn: "Alarm History",
    Warnconfiguration: "Alarm Configuration",
    Currenttimewarn: "Real Time Alarm",
    Diagnosemessage: "Diagnostic",
    Graphs: "Report Management",
    Onlinerate: "Online Ratio",
    Flowstatistics: "Traffic Statistics",
    Signalstatistics: "Signal Statistics",
    Softwareversion: "Software Version",
    Task: "Software Management",
    Softwarepackage: "Firmware Management",
    Upgrade: "Software Task",
    System: "System Management",
    Authoritymanagement: "Security Management",
    Customermanagement: "Customer Management",
    Usercontrol: "User Management",
    Parametermanagement: "Parameter",
    RemoteService: "Remote Service",
    AlarmContact: "Alarm Contact",
    North: "North",
    PrinterDriver: "PrinterDriver Management",
    HangingDevice: "Hanging Device",
    Amap: "Amap",
    google: "Google Map",
    /**
     * 云监测
     */
    /**
     * 云监测
     */
    FastAccess: "Fast Access",
    MonitoringScreen: "Monitor Screen",
    ProjectGroup: "Project List",
    TerminalList: "Terminal List",
    CloudMonitorTerminalList: "Terminal List",
    CollectConfigurate: "Collect Configuration",
    variableList: "Variable List",
    // EditCollection: '添加变量',
    // AddDevice: '添加设备',
    // AddTerminal: '添加终端',
    AlarmNotice: "Alarm Notice",
    AlarmContact: "Alarm Contact",
    AlarmList: "Alarm Record",
    HistoryRecords: "History Records",
    DevicesStatus: "Devices Status",
  },
  //首页
  dashboard: {
    Equipment: "Online Device Summary",
    offline: "off-line",
    online: "on-line",
    form: "DUTY CYCLE",
    summary: "Device Summary",
    chieffinancialofficer: "IoT Gateway",
    Router: "Router",
    PrintStream: "Printer Server",
    Serial: "Serial Server",
    Other: "Other",
    Serials: "serial number",
    name: "name",
    ADDRESS: "address",
    OfflineDevice: "Offline Device",
    OnlineDevice: "Online Device",
    AllDevices: "All Devices",
    message1: "The two passwords do not match",
    message2:
      "The user password consists of any number, string, underscore, and must have more than 6 digits and less than 16 digits",
    message3: "Modify Successfully",
    message4: "operation failure",
    message5: "Full screen is not supported",
    emailError: "Please enter the correct email address.",
    activateTips:
      "Verify that the message has been sent to your mailbox, please activate it within 30 minutes.",
    userPWDError: "The user password is incorrect.",
    oldPWDError: "Failed to modify, old password is incorrect.",
  },
  //个人
  user: {
    Personal: "Personal Information",
    ChangePassword: "Reset Password",
    exit: "Logout",
    User: "User ID",
    NICKNAME_RE: "Nick Name",
    UserRelated: "User Name",
    Gender: "Gender",
    Phones: "Phone",
    social: "WhatsApp/WeChat",
    Email: "Email",
    software: "Address",
    recently: "Last Login",
    modify: "Edit",
    Male: "Male",
    Female: "Female",
    OldPassword: "Old password",
    NewPassword: "New password",
    Confirm: "Confirm password",
    cancel: "Cancel",
    Confirmation: "Confirm",
    badconfirmstr: "Confirm Edit",
    BindingEmail: "Binding Email",
    EmailAddress: "Email Address",
    VerifyPassword: "Verify Password",
    Chinese: "简体中文",
    EmailBinding: "Email binding",
  },
  //设备列表
  devicelist: {
    SerialNumber: "Serial Number",
    Serial: "Serial Number",
    Equipment: "Group",
    DeviceName: "Device Name",
    IP: "IP Address",
    statevoid: "Status",
    traffic: "Data",
    signal: "Signal Strength",
    racingnetwork: "Network Mode",
    XoopsOnlineHandler: "Online Duration",
    TimeSeries: "Login/Logout",
    Version: "Version",
    schemaLocation: "Location",
    Operation: "Action",
    Please: "Select an action",
    restart: "Reboot",
    Factory: "Factory Reset",
    Backup: "Backup Configuration",
    personsto: "Device Logs",
    Timer: "Schedule Restart",
    Prototype: "Cancel Schedule Restart",
    reloadM2M: "Restart the M2M service",
    batch_groups_path: "Batch Edit Groups",
    batch: "no Refresh",
    L5Nrefresh: "5s Refresh",
    L10Nrefresh: "10s Refresh",
    L20Nrefresh: "20s Refresh",
    L60Nrefresh: "60s Refresh",
    connected: "Connected",
    not: "Disconnected",
    Disconnect: "Disconnect Remote Access",
    changes: "Edit Groups",
    Primary: "Primary Group",
    secondary: "Secondary Group",
    highlevel: "Tertiary Group",
    PLEASE: "Please select",
    Choose: "Unselect",
    Determine: "Confirm",
    CancelTst: "Cancel",
    removed: "Delete Device",
    message1: "Successfully deleted",
    message2: "Failed to delete",
    message3: "Device Not Selected",
    message4: "Successfully edited/updated",
    message5: "Failed to edit",
    message6: "Device not online is currently selected",
    message7: "This operation allows only a single device to operate",
    message8: "Please select the device before operating",
    message9: "Successfully connected",
    message10: "Failed to connect",
    message11: "Connection in progress",
    message11: "Successful disconnect",
    message12: "Operation Failure",
    message13: "Successfully disconnected",
    message14: "Device name cannot be empty",
    message15: "Successfully edited",
    message16: "The device location cannot be empty",
    search1: "Search",
    search2: "Search",
    search3: "Search",
    search4: "Search",
    search5: "Search",
    search6: "Search",
    search7: "Search",
    search8: "Search",
    search9: "Search",
    search10: "Search",
    search11: "Search",
    search12: "Search",
    FirstLevelProject: "First Level Project",
    SecondLevelProject: "Second Level Project",
    DeviceAddress: "Device Address",
    Name: "Name",
    connecttodevice: 'connect to device',
    Disconnect: "Disconnect",
    disbad: 'Disconnection failed',
    WANPortTraffic: "WAN Port Traffic",
    _3GWAN1Traffic: "3G WAN1 Traffic",
    _3GWAN2Traffic: "3G WAN2 Traffic",
    repair: 'Are you sure you want to repair this device?',
    progress: 'Executing...',
    contactCustomerService: 'Execution successful. If the device still has problems, please contact customer service!',
    Detection: 'Device detection',
    confirmRepir: 'Are you sure you want to detect and repair all potentially problematic devices?',
    waitRun: 'Waiting for execution...',
    noDeviceRepair: 'No devices need repair yet',
    total: 'Total number',
    success: 'Success',
    fail: 'Failure',
  },
  gateone: {
    closeTips: "Close prompt",
    isUsed: "The device remote connection is already in use",
    successConect: "The connection is successful",
    failConnect: "connection failed",
    connecting: "Connection in progress",
  },
  //设备远程操作组件
  Dialog: {
    affected: "Affected Devices",
    cancel: "Cancel",
    Determine: "Confirm",
    translators: "Select time",
    interface: "Interface serial number",
    prompt: "Prompt",
    Weltordnung: "Acquire Success",
    download: "Download now",
    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    Backup: "Backup Configuration",
    personsto: "Device Logs",
    SkinVector: "Successfully retrieved",
    allocator: "Retrieving",
    WaitForMultipleObjects: "Failed to get",
    operation: "Successfully operated",
    BoxapiJSONOperation: "Failed to operate",
    remoteservice: "Remote Service",
    executing: "Executing, please do not repeat the operation!",
  },
  //设备详细信息
  particulars: {
    modify: "Edit",
    Add: "Add a Remote Service",
    batch: "No Refresh",
    L5Nrefresh: "5s Refresh",
    L10Nrefresh: "10s Refresh",
    L20Nrefresh: "20s Refresh",
    L60Nrefresh: "60s Refresh",
    WAD_NUMBER_RETURN: "Return",
    SystemUptime: "System Information",
    DeviceName: "Device Name",
    Grouping: "Device Group",
    Professional: "System Name",
    Models: "Device Model",
    Version: "Software Version",
    Kernel: "Kernel Version",
    Product: "Product Model",
    Serial: "Serial Number",
    Hardware: "Hardware Type",
    hardware: "Hardware Version",
    mac: "MAC-Address",
    network: "Network Mode",
    VendorModel: "Manufacturer",
    deviceID: "Device ID",
    ADDRESS: "Address",
    detailed: "Detailed Address",
    UpgradeTime: "Update Time",
    Customer: "Customer",
    GeneralInfo: "General Info",
    statusClear: "Clear online/offline time",
    StateManager: "Status Information",
    connection: "Connection Status",
    foreach: "First Login Time",
    CurTime: "Total Online Duration",
    beforeoffline: "Total Offline Duration",
    TimeModeSetOffline: "Offline Time",
    SCLocalTime: "Offline Duration",
    LoginTime: "Login Time",
    online_updated: "Online Duration",
    NetworkTraffic: "Network Traffic",
    traffic: "Today’s traffic",
    Monthly: "This month’s traffic",
    software: "Last 7 days’ traffic",
    addToTrafficDensityMap: "Total Traffic",
    WAN: "Wired WAN Status",
    IP: "IP Address",
    gateway: "Gateway",
    NonContiguousSubnetMask: "Subnet Mask",
    NETWORK: "Network Protocol",
    DNS1: "DNS1",
    DNS2: "DNS2",
    NETWORK_FAUX_QUEUE: "Connection Duration",
    Connection: "Connection Status",
    UpdateTime: "Update Time",
    wan3g1: "Mobile Network Status(3gwan1)",
    wan3g2: "Mobile Network Status(3gwan2)",
    wan3g1IP: "IP Address",
    wan3g1IPV6: "IPV6 Address",
    wan3g1gateway: "Gateway",
    wan3g1NonContiguousSubnetMask: "Subnet Mask",
    wan3g1NETWORK: "Network Protocol",
    wan3g1DNS1: "DNS1",
    wan3g1DNS2: "DNS2",
    MODULE_FILE_SUFFIX: "Module Model",
    Operator: "Operator",
    supported: "Supporting Network Mode",
    IMSI: "IMSI",
    IMEI: "IMEI",
    ICCID: "ICCID",
    current: "Current Network Standard",
    SignalStrengths: "Signal Strength",
    SIM: "SIM Status",
    wan3g1NETWORK_FAUX_QUEUE: "Connection Duration",
    wan3g1Connection: "Connection Status",
    wan3g1UpdateTime: "Update Time",
    profile: "Wired LAN Status",
    profileIp: "IP Address",
    profilegateway: "Gateway",
    profileNonContiguousSubnetMask: "Subnet Mask",
    profileNETWORK: "Network Protocol",
    profileConnection: "Connection Status",
    profileUpdateTime: "Update Time",
    GPS: "GPS",
    long: "Longitude",
    lat: "Latitude",
    service: "Remote Service Information",
    YTCommunityTag: "Community Name",
    password: "Password",
    YTCommuniIP: "IP Address",
    Operation: "Action",
    rthq_infobase: "Base Station Information",
    MNC: "MNC",
    MCC: "MCC",
    LocationListener: "Location Information",
    networkRemoveOk: "Network Type",
    unknown: "Unknown",
    connected: "Connected",
    not: "Disconnected",
    blendmode: "Single Mode Single Card",
    discard_year: "Single mode dual card",
    SerialServer: "Serial Server",
    PrintServer: "Print Server",
    model_id: "Dual mode dual card",
    MultiSimVariants: "Multi Mode Multi Cards",
    Modeling: "Wired Mode",
    G3G4: "3G/4G",
    G4G5: "4G/5G",
    compatibility: "Compatible Mode",
    addressStrings: "Static Address",
    refreshHaves: "Card Inserted",
    info_normal_color: "Card not found",
    package_pin: "No Pin Number",
    IMEI_CODE_LEN: "No PUK Number",
    aac_card_type: "Abnormal Card",
    AtomServiceDualParser: "Delete Remote Service",
    si_modify: "Edit",
    reset_type: "Reset",
    Day: "d ",
    hours: "h ",
    minutes: "m ",
    seconds: "s",
    GPSrequire: "(GPS Reporting)",
    Processmanagement: "System Service",
    Processname: "Service Name",
    Processstatus: "Server Status",
    Processcontrol: "Server Control",
    ProcessDate: "Update Time",
    Devicenotonline: "Device not online",
    NotSupport: "The device does not support this feature",
    dropbear: "Dropbear",
    smartlink: "Smartlink",
    uhttpd: "Uhttpd",
    smartant: "Smartant",
    loc: "Loc",
    watchcat: "Watchcat",
    "ss-redir": "Mptcp",
    configmgr: "Configmgr",
    m2mMqtt: "M2mMqtt",
    watchfox: "Watchfox",
    firewall: "Firewall",
    M2MProxy: "M2M",
    smartm2m: "M2M",
    mwan3: "Mwan3",
    socat: "Socat",
    smartcat: "Socat",
    openvpn: "OpenVPN",
    repeater: "Repeater",
    IOControl: "IO Control",
    ipsec: "IPSec",
    eoip: "EOIP",
    pptp1: "PPTP",
    gre1: "GRE",
    wlan0: "WIFI",
    l2tp1: "L2TP",
    Running: "Running",
    Stop: "Stop",
    startup: "Start",
    Restart: "Restart",
    operation: "Successful operation",
    BoxapiJSONOperation: "Operation failed",
    message1: "The device is not online ",
    message2: "This action adds a remote service to the device",
    message3: "Prompt",
    message4: "Confirm",
    message5: "Cancel",
    message6: "Successfully Added",
    message7: "Failed to add",
    message8: "Cancel add",
    message9: "The device is not online ",
    message10: "This action deletes the device remote service",
    message11: "Successfully deleted",
    message12: "Failed to delete",
    message13: "Cancel delete",
    message14: "Determine to modify the longitude of the equipment",
    message15: "Successfully edited",
    message16: "Failed to edit",
    message17: "Latitude for",
    wan2: "Mobile Network Status(3gwan2)",
    wirelessWifi: "Wireless Wifi",
    networkStatus: "Network Status",
    trafficClear: "Clear traffic",
    hanging: "Hanging Devices",
    disOpened: "DisOpened",
    OnlineTimes: "Online times",
    OfflineTimes: "Offline times",
    networkMonitoring: "Network Monitoring",
    frpc: 'frpc service'
  },
  // 无线网路
  wireless: {
    interfaceName: "Interface Name",
    interfaceStatus: "Interface Status",
    running: "Running",
    stop: "Stop",
    ip: "IP Address",
    subnetMask: "Subnet Mask",
    gateway: "Gateway",
    protocol: "Protocol",
    DNSServer: "DNS Server",
    hops: "Hops",
    connectTime: "Connect Time",
    uplink: "Uplink Traffic",
    downlink: "Downlink Traffic",
  },
  //分组管理
  groupinglist: {
    GroupName: "Group",
    GroupByTests: "Superior",
    belonging: "Customer",
    contact_to: "Belong user",
    Creator: "Creator",
    services: "Created By",
    account_root: "Username",
    RemoteMailboxes: "Password",
    IPaux: "Remote IP",
    Update: "UpdateTime",
    Operation: "Action",
    Add: "Add",
    Migrate: "Migrate",
    MigrationGroup: "Migration Group",
    N2nVersion: "N2n Version",
    port: "Port",
    loadData: "Add Group",
    optional_groups: "Edit Group",
    group1: "Primary Group",
    group2: "Secondary Group",
    AllowMultipleLogins: "Allow multiple logins",
    DonotAllowmultiplelogins: "Do not allow multiple logins",
    cancel: "Cancel",
    Determine: "Confirm",
    GroupDef_delete: "Delete group",
    message1: "Remote account must be more than 6 bits and less than 18 bits",
    message2: "Remote password must be more than 6 bits and less than 18 bits",
    message3: "Incorrect remote IP, please check again",
    message4: "Successfully edited",
    message5: "Group name exist",
    message6: "Remote account exist",
    message7: "Device cannot be deleted because it is under a group",
    message8: "Operation Failure",
    message9: "Please add remote account information",
    message10: "The default group cannot be deleted",
    message11: "Successfully deleted",
    message12: "Failed to delete",
    message13: "successfully added",
    message14: "Operation Failure",
    message15: "Successful migration",
    message16: "Migration failed",
    message17: "Please select a group",
    platformprint: "Remote printing",
    ReconStandardServicePanel: "Standard service",
    Standard: "Required",
    Optional: "optional",
    selector: "Please select",
    Choose: "Unselect",
    search1: "Search",
    search2: "Search",
    search3: "Search",
    search4: "Search",
    search5: "Search",
    search6: "Search",
    search7: "Search",
    search8: "Search",
    search9: "Search",
    userpwdChineseCheck: "Account password cannot contain Chinese",
    notEmpty: "Can not be empty",
    ipInput: "Please enter remote IP",
    groupNameInput: "Please enter a group name",
    firstLevelGrouping: "first-level grouping",
    secondaryGrouping: "secondary grouping",
    threelevelgrouping: "three-level grouping",
    GroupingLevel: "Grouping level",
    mobileGrouping: "mobile grouping",
    bridging: "Bridging",
    remoteBridge: "Remote Bridge",
    bridgePrompt: "When the bridge is selected, the remote IP address will be set to be the same as the default address of the gateway LAN IP. At this time, the Superlink network can directly access the terminals connected to the gateway LAN.",
    bridgePrompt2: "When Bridged is unchecked, the remote IP address will be reverted to the default IP address (172.16.100.2). At this time, the Superlink network will access the terminal connected to the LAN of the gateway remotely across network segments.",
    // 该远程服务版本不支持桥接
    bridgePrompt3: "The remote service version does not support bridging",
  },
  //异常列表
  unusuallist: {
    Serial: "Serial Number",
    DeviceName: "Device Name",
    Version: "Software Version",
    DeleteTime: "Deleted Date",
    Operation: "Action",
    prompt: "Prompt",
    Tetx: "Restore device to device list. Do you want to continue?",
    confirmButtonText: "Confirm",
    cancelButtonText: "Cancel",
    success: "Successfully restored",
    RestoreMetaData: "Failed to restore",
    search1: "Search",
    search2: "Search",
    search3: "Search",
    search4: "Search",
  },
  //配置列表
  configuration: {
    createFile: "File Name",
    ntfs_file_open: "File Size(KB)",
    heir_do: "Upload By",
    Upload: "Upload Time",
    noteId: "Remark",
    Operation: "Action",
    Add: "Add",
    Configuration: "Add configuration files",
    add_action: "Click on the upload",
    file_name: "The file format must be.tar.gz",
    uploaders: "Upload",
    modifycollection: "Edit Configuration",
    justUploaded: "Edit Configuration",
    successfully: "Failed to upload",
    TestDelete: "Successfully edited",
    bdb_delete: "Failed to delete",
    m_pr_modifyS: "Successfully edited",
    onCallModifying: "Failed to edit",
    t_config_file: "Delete configuration",
    databases: "This action will persist the data. Do you want to continue?",
    Determine: "Confirm",
    cancel: "Cancel",
    Optional: "Optional",
    search1: "Search",
    search2: "Search",
    search3: "Search",
    search4: "Search",
    search5: "Search",
  },
  //设备配置
  ConfigSetting: {
    successSetting: "Configuration is successful",
    failSetting: "Configuration failed",
    L2TP: "L2TP",
    PPTP: "PPTP",
    bandwidth: "Band Width",
    channel: "Channel",
    GroupSelection: "Group Selection",
    Searchgroup: "Search group",
    DeviceSelection: "Device Selection",
    pleaseChoose: "please Choose",
    Protocol: "Protocol",
    Staticaddress: "Static address",
    DHCPclient: "DHCP client",
    IPv4address: "IPv4 address",
    IPv4netmask: "IPv4 netmask",
    UsecustomDNSservers: "Use custom DNS servers",
    SaveApply: "Save & Apply",
    DHCP: "Hostname to send when requesting DHCP",
    IPv4gateway: "IPv4 Gateway",
    NetworkType: "Network Type",
    Automatic: "Automatic",
    PAPCHAPusername: "PAP/CHAP username",
    PAPCHAPpassword: "PAP/CHAP password",
    custom: "Custom",
    AuthenticationType: "Authentication Type",
    ICMPCheck: "ICMP Check",
    Disable: "Disable",
    Enable: "Enable",
    isEnable: "Enabled",
    disEnable: "Disabled",
    ServiceType: "Service Type",
    Dialnumber: "Dial number",
    LocalIPAddress: "Local IP Address",
    Hostname: "Hostname",
    Timezone: "Timezone",
    Language: "Language",
    WANMode: "WAN Mode",
    andWired: "3G/4G and Wired",
    Wired: "only Wired",
    G3G4: "only 3G/4G",
    G4G5: "4G/5G",
    NTPclient: "Enable NTP client",
    NTPserver: "Provide NTP server",
    servercandidates: "NTP server candidates",
    WebAccess: "Web Access",
    Changes: "Changes the port for accessing the panel of web",
    Port: "Port",
    SSHAccess: "SSH Access",
    Dropbear:
      "Dropbear offers SSH network shell access and an integrated SCP server",
    Interface: "Interface",
    unspecified: "Unspecified",
    Passwordauthentication: "Password authentication",
    withpassword: "Allow root logins with password",
    Gatewayports: "Gateway Ports",
    ADD: "ADD",
    protection: "Enable SYN-flood protection",
    Dropinvalidpackets: "Drop invalid packets",
    Input: "Input",
    Output: "Output",
    Forward: "Forward",
    accept: "Accept",
    drop: "Drop",
    reject: "Reject",
    ModeUrl: "Mode",
    Disables: "Disable",
    while: "While List",
    black: "Black List",
    Domain: "Domain",
    Name: "Name",
    Externalzone: "External zone",
    ExternalIPaddress: "External IP address",
    Internalzone: "Internal zone",
    InternalIPaddress: "Internal IP address",
    operating: "Operating",
    delete: "Delete",
    Other: "Other",
    DISABLE: "DISABLE",
    DEABLE: "DEABLE",
    SourceIPaddress: "Source IP address",
    Rule: "Rule",
    ExternalIPaddress: "External IP address",
    InternalIPaddress: "Internal IP address",
    Sourceport: "Source port",
    EnableNATLoopback: "Enable NAT Loopback",
    Extraarguments: "Extra arguments",
    edit: "Edit",
    cancel: "Cancel",
    determine: "Determine",
    Ststem: "System",
    Administration: "Administration",
    Firewall: "Firewall",
    DomainFilter: "Domain Filter",
    KeywordFilter: "Keyword Filter",
    PortForwards: "Port Forwards",
    M2MPlatform: "M2M Platform",
    StartM2MPlatformControl: "Start M2M Platform Control",
    HeartbeatInterval: "Heartbeat Interval(s)",
    Heartbeattimeouttimes: "Heartbeat timeout times",
    reportingFrequency: "Location data reporting frequency(s)",
    NetStatusInterval: "Net Status Interval(s)",
    ServerIP: "Server IP",
    Successfulconfiguration: "Successfulcon figuration",
    Configurationerror: "Configuration error",
    Nochangesmade: "No changes made",
    Pleasecheck: "Please check the input",
    BasicSettings: "Basic Settings",
    WirelessNetwork: "Wireless Network",
    Mode: "Mode",
    HideESSID: "Hide ESSID",
    WMMMode: "WMM Mode",
    WirelessSecurity: "Wireless Security",
    Encryption: "Encryption",
    Key: "Key",
    AccesspointAP: "Access point AP",
    wifimessage: "Wifi key length is at least 8 digits",
    OnOff: "On/Off",
    L2TPServer: "L2TP Server",
    PapchapUsername: "PAP/CHAP Username",
    PapchapPassword: "PAP/CHAP Password",
    PowerOn: "Power On",
    UseDefaultGateway: "Use Default Gateway",
    LCPResponseFailureThreshold: "LCP Response Failure Threshold",
    LCPResponseInterval: "LCP Response Interval",
    AdditionalPPPParameters: "Additional PPPP arameters",
    VpnServer: "Vpn Server",
    MPPEEncryption: "MPPE Encryption",
    Smartlink: "Smartlink",
    smartnms: "Smartnms",
    PortalAuthentication: "Portal Authentication",
    Enable: "Enable",
    Address: "Address",
    PageUpdate: "Page Update",
    JumpAddressAfterAuthentication: "Jump Address After Authentication",
    SessionTimeout: "Session Timeout",
    MaximumNumberOfCustomers: "Maximum Number Of Customers",
    UncertifiedEquipment: "Uncertified Equipment",
    CertifiedEquipment: "Certified Equipment",
    AuthenticationFreeMACAddress: "Authentication Free MAC Address",
    IgnoreWiredDevices: "Ignore Wired Devices",
    debug: "debug",
    not: "not",
    error: "error",
    information: "information",
    basicConfiguration: "Basic Configuration",
    redirect: "Communication Rules",
    name: "Name",
    protocols: "Protocols",
    SRC: "SRC",
    SRCIp: "SRC IP",
    dest: "Target Area",
    dest_ip: "Target IP",
    SNAT: "SNAT IP",
    TCP: "TCP",
    UDP: "UDP",
    TCP_UDP: "TCP & UDP",
    ICMP: "ICMP",
    anyone: "Anyone",
    pleaseInput: "please Input",
    anyoneDest: "Anyone area",
    deviceSelectTips: "Show only a list of connected devices",
    SNSearch: "Search by SN",
    filter: "Filter",
    interfaceSetting: "Interface Setting",
    deiveceSetting: "Deivece Configuration",
    trandform: "Wan to LAN",
    disabled: 'disabled',
    UseGatewayHops: 'Use gateway hops',
    useTheDns: 'Use the DNS server advertised by the peer',
    activityTimeout: 'activity timeout',
    resetMTU: 'reset MTU',
    useTheCustomDns: 'Use a custom DNS server',
    GetIPv6address: 'Get IPv6 address',
    IPSecConfiguration: 'IPSec configuration',
    L2TPKey: 'L2TP Key',
    optional: 'optional',
    SIMmode: 'SIM mode:',
    Dualcardbackup: 'Dual card backup:',
    SIM1APNaccesspoint: 'SIM1 APN access point:',
    SIM1username: 'SIM1 username:',
    SIM1password: 'SIM1 password:',
    SIM1authenticationtype: 'SIM1 authentication type:',
    SIM1IPprotocol: 'SIM1 IP protocol:',
    SIM1carriermode: 'SIM1 carrier mode:',
    ChinaMobile: 'China Mobile',
    ChinaUnicom: 'China Unicom',
    ChinaTelecom: 'China Telecom',
    SIM1localIPaddress: 'SIM1 local IP address:',
    SIM1PINcode: 'SIM1 PIN code:',
    SIM1cardtype: 'SIM1 card type:',
    publicnetworkcard: 'public network card',
    privatenetworkcard: 'private network card',
    SIM1detectionstrategy: 'SIM1 detection strategy:',
    RSSIsignal: 'RSSI signal',
    Pingdelay: 'Ping delay',
    mixedstrategy: 'mixed strategy',
    SIM1RSSIThreshold: 'SIM1 RSSI threshold:',
    SIM1LatencyThreshold: 'SIM1 Latency threshold:',
    scope1: "When the RSSI value is lower than the threshold, it is judged that the dial-up connection is interrupted. Value range (0,30)",
    scope2: "When the ping detection delay exceeds the threshold, it is determined that the dial-up connection has been interrupted. The unit is milliseconds. Value range (100,3000)",
    SIM1detectionaddress: 'SIM1 detection address:',
    SIM1detectioncycle: 'SIM1 detection cycle:',
    scope3: "The frequency of detecting network connections, in seconds",
    SIM1PingCount: 'SIM1 Ping Count:',
    SIM2APNaccesspoint: 'SIM2 APN access point:',
    SIM2username: 'SIM2 username:',
    SIM2password: 'SIM2 password:',
    SIM2authenticationtype: 'SIM2 authentication type:',
    SIM2carriermode: 'SIM2 carrier mode:',
    SIM2localIPaddress: 'SIM2 local IP address:',
    SIM2PINcode: 'SIM2 PIN code:',
    SIM2cardtype: 'SIM2 card type:',
    SIM2detectionstrategy: 'SIM2 detection strategy:',
    SIM2RSSIThreshold: 'SIM2 RSSI threshold:',
    SIM2LatencyThreshold: 'SIM2 Latency threshold:',
    SIM2detectionaddress: 'SIM2 detection address:',
    SIM2detectioncycle: 'SIM2 detection cycle:',
    SIM2PingCount: 'SIM2 Ping Count:',
    Restartafternetworkdisconnection: 'Restart after network disconnection:',
    AlibabaCloudEagleCard: 'Alibaba Cloud Eagle Card:',
    defaultcarrier: 'default carrier',
    disabledAccess: 'Wan Web access is disabled by default:',
    SIMDefaultConfig: 'SIM Default Config:',
    enable: 'Enable',
    server: 'Server address',
    upgrade: 'Firmware available on the platform',
    mqttQos: 'MQTT service quality',
    mqttAlive: 'MQTT keep-alive period',
    status: 'Status',
    v2tcpServer: 'V2_TCP connection',
    v2mqttServer: 'V2_MQTT connection'
  },
  // 设备配置-> 有线网络
  wire: {
    wireNetwork: "Wire Network",
    normalSetting: "Normal Setting",
    functionConfiguration: "Function Configuration",
    DHCPServer: "DHCP Server",
    ignoreInterface: "Ignore this interface",
    ignoreTips: "DHCP service is not provide on this interface.",
    start: "Start",
    startTips: "The starting allocation base address of the network address.",
    customerNum: "Customer Number",
    customerNumTips: "Maximum number of address assignment",
    leaseTerm: "Lease Term",
    leaseTermTips:
      "The minimum expiration time of the leased address is 2 minutes(2m).",
    DHCPOptions: "DHCP Options",
    DHCPOptionsTips:
      "Set additional DHCP options, such as 6,114.114.114.114 to notify different DNS servers to clients.",
    DHCP: "DHCP Client",
    changeProtocol: "Switch Protocol",
    confirmChange: "Are you sure you want to switch the protocol?",
    hostname: "The hostname sent when requesting DHCP",
  },
  // 设备配置-> 移动网络
  mobile: {
    mobileNetwork: "Mobile Network",
  },
  // 设备配置-> 防火墙
  firewall: {
    addNAt: "Add Source NAT",
    name: "Name",
    protocal: "Protocal",
    protocalTips:
      'You can also select "- Custom --" to define multiple protocols, and spaces need to be added between multiple protocols',
    sourceArea: "source Area",
    sourceIp: "Source Ip Address",
    targetArea: "Target Area",
    targetIp: "target Ip Address",
    SNATIp: "SNAT IP Address",
    SNATIpTips:
      "Rewrites the source address of the matching traffic to the specified address.",
    additonalParameters: "Additonal Parameters",
    additonalParametersTips:
      "Additional parameters passed to iptables. Use with care!",
    all: "All",
  },
  // 设备配置-> 端口转发
  port: {
    portForwards: "Port Forwards",
    outerPort: "Outer Port",
    innnerPort: "Inner Port",
    enable: "Enable",
    addPortForwards: "Add Port Forwards",
    other: "Other",
    addTips:
      "You have unfilled options. Are you sure to ignore them and add them?",
    tips: "Tips",
    innerPort: "Inner Port",
  },
  // 设备配置-> smartlink
  smartlink: {
    general: "General Configuration",
    modeConfiguration: "Mode Configuration",
    enable: "Enable",
    uplink: "Uplink Device",
    downlink: "Downlink Device",
    connectConfiguraton: "Connect Configuraton",
    serialPort: "Serial Port Setting",
    interface: "Interface",
    baudRate: "Speed",
    dataBits: "Data Bits",
    stopBits: "Stop Bits",
    checkBits: "Check Bits",
    flowControl: "Flow Control",
    senior: "Advanced Configuration",
    enableSubcontracting: "Enable Subcontracting",
    subcontractingInterval: "Subcontracting Interval",
    subcontractingIntervalTips: "millisecond",
    subcontractingLength: "Subcontracting Length",
    subcontractingLengthTips: "bytes",
    name: "name",
    workingMode: "Working Mode",
    targetAddress: "Target Address",
    status: "Status",
    connected: "Connected",
    listening: "Listening",
    partialConnected: "Partial Connected",
    unknown: "Unknown",
    disconnect: "Disconnect",
    connectNumber: "Connect Number",
    protocal: "Protocal",
    listenPort: "Listen Port",
    serverAddress: "Server Address",
    serverTips: "Address:Port",
    serverError: "Server address input error",
    platformName: "Platform name",
    DTUNumber: "DTU Number",
    corporateLogo: "Corporate Logo",
    deviceType: "Device Type",
    encyptionKey: "Encyption Key",
    GPSLogitude: "GPS Logitude",
    GPSLatitude: "GPS Latitude",
    keyTime: "Key Time",
    deviceNumberPrefix: "Device Number Prefix",
    messagePrefix: "Message Prefix",
    messagePrefixTips:
      "A standard hexadecimal string starting with 0x or 0x, up to 4 bytes",
    messageLength: "Message length field bytes",
    messageLengthTips: "bytes",
    messageSequenceNumber: "Message Sequence Number",
    deviceID: "Device ID",
    deviceIDTips:
      "Supports ASCII and hexadecimal strings. If it is a hexadecimal string, it must be a standard hexadecimal string that begins with 0x or 0x, and the maximum length is 16 bytes",
    CRCCheck: "CRC Check",
    messageSuffix: "Message Suffix",
    deviceName: "Device Name",
    username: "Username",
    password: "Password",
    log: "Log File",
    subscribeTopics: "Subscribe Topics",
    reportingSubject: "Reporting Subject",
    customerId: "Customer Id",
    MqttSurvivalCycel: "Mqtt Survival Cycel",
    enableHearbeat: "Enable Hearbeat",
    heartbeatInterval: "Heartbeat Interval",
    heartbeatIntervalTips: "Seconds",
    heartbeatContent: "Heartbeat Content",
    heartbeatContentTips:
      "Supports ASCII and hexadecimal strings. If it is a hexadecimal string, it must be a standard hexadecimal string that starts with 0x or 0x and has a maximum length of 64 bytes",
    debug: "Debug",
    TCPSurvivalFreeTime: "TCP Survival Free Time",
    TCPSurvivalDetectionInterval: "TCP Survival Detection Interval",
    TCPSurvivalDetectionMax: "TCP Survival Detection Maximum",
    saveLogNumber: "Number of log files retained",
    logSize: "Log file size",
    logPriority: "Log Priority",
    download: "Download",
    pleaseChoose: "Please Choose",
    TCPServer: "TCP Server",
    TCPClient: "TCP Client",
    UDPServer: "UDP Server",
    UDPClient: "UDP Client",
    RealCom: "Real serial mode",
    MQTTClient: "MQTT Client",
    UART: "Universal serial port",
    PassThrough: "Pass-Through",
    ModbusJSON: "Modbus JSON",
    ModbusRTU: "Modbus RTU",
    FourGDTU: "Four G DTU", // 广东质安
    SCTCOEM: "Agreement of Shenzhen Construction Commission", // 广东质安
    Custom: "Custom",
    CYKJOEM: "Chaoyou Technology", // 超友科技
    SHIERYEOEM: "China metallurgical Group", // 中国二十冶集团有限公司
    EHBOEM: "E Environmental Protection", // 广东E环保
    msgError: "It must be prefixed with either 0x or 0x",
    nameError: "Please enter the name",
    seconds: "seconds",
    info: "Info",
    notice: "Notice",
    alarm: "Alarm",
    error: "Error",
    deadly: "Deadly",
    alert: "Alert",
    emergency: "Emergency",
    modbusTCPMain: "Modbus TCP Master",
    modbusTCPFollow: "Modbus TCP Slave",
    modbusRTUMain: "Modbus RTU Master",
    modbusRTUFollow: "Modbus RTU Slave",
    slaveAddrees: "Slave Addrees",
    slavePort: "Slave Port",
    slaveID: "Slave ID",
    sync_local_data: 'Synchronize local data',
    syncTips: 'Synchronize data in local acquisition instructions',
    slaveIDTips: "Value range: 0 ~ 255",
    responeTimeout: "Response Timeout",
    ms: "ms",
    byteInterval: "Byte Interval",
    modbusDebug: "Modbus Debug Switch",
    localServer: "Local Server",
    subid: "sub equipment Id",
    AIOT: "Alibaba Cloud IoT Platform",
    UDSServer: "UDS Server",
    instanceId: "Instance ID",
    productKey: "Product Key",
    deviceName: " device name",
    deviceSecret: "Device Secret",
    uploadInter: "Report cycle",
    snmpVersion: "SNMP version",
    snmpGroupName: "SNMP read and write group name",
    udsServerPath: "server address",
    collection: 'Collection',
    resendTimes: 'Retry times',
    resendError: 'Value range: 0 ~ 5',
    ModbusASCIIMaster: 'Modbus ASCII Master',
    ModbusASCIIslave: 'Modbus ASCII Slave',
    s7Client: 'S7 client',
    rackNumber: 'rack number',
    s7_slot: 'slot',
    CollectionCycle: 'collection cycle',
  },
  // 设备配置 -> wifi
  wifi: {
    auto: "Auto",
    CCMP: "Mandatory CCMP (AES)",
    TKIP: "Mandatory TKIP",
    CCMP_TKIP: "Mandatory TKIP and CCMP (AES)",
    static: "Static Address",
  },
  // 设备配置-> 网络接口信息
  network: {
    networkInfo: "Basic Information Of Network Interface",
    interfaceName: "Interface Name",
    enableStatus: "Enable Status",
    enabled: "Enabled",
    disable: "Disable",
    ipAddress: "IP Address",
    subnetMask: "Subnet Mask",
    gateway: "Gateway",
    protocal: "Protocal",
    connectTime: "Connect Time",
    DNSServer: "DNS Server",
    hops: "Hops",
    upstreamTraffic: "Upstream Traffic",
    downstreamTraffic: "Downstream Traffic",
    staticAddress: "Static Address",
  },
  L2TP: {
    routeTips: "If left blank, the default route is not configured",
    LcpOneTips:
      "After a specified number of LCP responses fail, the link is assumed to be disconnected and 0 is ignored",
    LcpTwoTips:
      "A timed LCP response (in seconds) is only valid when combined with failure thresholds",
    assignedAddress: "Manually Assigned Address",
    assignedAddressError: "Incorrect address assignment format",
    ipTips: "Local IP: remote IP",
  },

  // 请求
  request: {
    timeout: "Request timeout, please try again",
    smartlinkError: "Request timed out, please check device!",
  },
  //批量配置
  firmware: {
    hFirstTask: "Create Task",
    equipment: "Device",
    multitasking: "Task",
    VI_Task: "Description",
    AsyncOperationStatus: "Status",
    createFile: "File Name",
    timerfunction: "Updated Time",
    Operation: "Action",
    configuration: "Add batch configuration tasks",
    Equipment: "Operable equipment",
    file: "File",
    group1: "Primary Group",
    group2: "Secondary Group",
    group3: "Tertiary Group",
    cancel: "Cancel",
    Determine: "Confirm",
    $_blacklistedScalarArgsCallback: "Create Task Successfully",
    commands: "Command sent successfully",
    connection: "Remote connection successful",
    define: "Downloading",
    DownloadEventNotifier: "Download Complete",
    upgrading: "Upgrading",
    upgrade_drush_command: "Upgrade complete",
    username_last_used: "ERROR Incorrect username or password",
    tempfile: "404 file does not exist",
    Translators: "Connection timeout, unable to download",
    zxid_add_name_field: "Domain resolution error",
    DOWNLOADER_CLIENT_TLS_METHOD: "Download timeout",
    boolCheckPingURI: "MD5 check failed",
    upgrade_alter_tables: "Upgrade failed",
    keymaster_error_t: "Failed to upgrade, unknown error",
    handle_remote_sigint: "Remote connection failed",
    BAG_FILTER_EQUIPMENT: "Device is offline, try again later",
    TestDelete: "Successfully deleted",
    intbdb_delete: "Failed to delete",
    CompositeTask: "Delete Task",
    MissionAccomplished: "Mission Accomplished",
    Ongoing: "Ongoing",
    search1: "Search",
    search2: "Search",
    search3: "Search",
    search4: "Search",
    search5: "Search",
  },
  //统计报表四合一
  ReportManagement: {
    Rates: "Online Rate",
    Units: "Unit",
    signals: "Signal Value",
    number: "Number",
    Version: "Software Version",
    datatype: "No data",
    setPrompt: "Prompt",
    Determine: "Determine",
  },
  //统计日期组件
  DateSelect: {
    StatisticType: "Statistic Type",
    year: "year",
    month: "month",
    data: "date",
    hour: "hour",
    minute: "minute",
    Group1: "Primary Group",
    Group2: "Secondary Group",
    Group3: "Thirdly Group",
    Device: "Device",
    luaall_c: "All",
    Statistical: "Statistics",
    PleaseChoose: "Please Choose",
    message1: "Please Select a Group",
    message2: "Please Select a Device",
    message3: "Please Select a year",
    message4: "Please Select The Month",
    message5: "Please Select a Date",
    message6: "Please Select An Hour",
    singleMonth: "month",
    singleDate: "date",
    singlehour: "h",
    singleminute: "min",
    st: "st",
    rd: "rd",
    nd: "nd",
    th: "th",
  },
  // 月份英文
  month: {
    "1": "January",
    "2": "February",
    "3": "March",
    "4": "April",
    "5": "May",
    "6": "June",
    "7": "July",
    "8": "August",
    "9": "September",
    "10": "October",
    "11": "November",
    "12": "December",
  },
  //固件管理
  softwarepackage: {
    Software: "File Name",
    Version: "Software version",
    types: "Software Type",
    SoftwareSize: "Size(KB)",
    adminhelpuploadusers: "Uploader",
    m_UploadOMeter: "Upload Time",
    SynchronizationStatus: "Synchronization Status",
    Operation: "Action",
    Add: "Add",
    addVarCopy: "Add packages",
    add_action: "Click on the upload",
    file_name: "The file format must be.tar.gz",
    uploaders: "Uploading",
    Modify: "Modify Package",
    FirmwareAuthority: "Firmware Authority",
    VisibleUser: "Visible User",
    DesignatedCustomer: "Designated Customer",
    AllUsers: "All Users",
    SystemAdministrator: "System Administrator",
    Cancel: "Cancel",
    Confirm: "Confirm",
    SuccessfullyModified: "SuccessfullyModified",
    onCallModifying: "Failed to edit",
    Pleaseselectacustomer: "Please select a customer",
    justUploaded: "Successfully uploaded",
    successfully: "Failed to upload",
    TestDelete: "Successfully deleted",
    bdb_delete: "Failed to delete",
    remove_pkg: "Delete package",
    PLEASE: "Please select",
    search1: "Search",
    search2: "Search",
    search3: "Search",
    search4: "Search",
    search5: "Search",
    search6: "Search",
    search7: "Search",
    UpgradePackage: "Upgrade Package",
    PatchPackage: "Patch",
    OrdinaryFile: "Ordinary file",
    Synced: "Synced",
    NotSynchronized: "Not Synchronized",
  },
  //软件任务
  upgrade: {
    FutureTask: "Task Name",
    equipment: "Device",
    TaskStatus: "Description",
    addDistributionPackages: "Add upgrade task",
    completion: "Task Status",
    createFile: "File Name",
    UPDATE_TO: "Updated Time",
    Operation: "Action",
    hFirstTask: "Create Task",
    group1: "Primary Group",
    group2: "Secondary Group",
    group3: "Tertiary Group",
    adding: "Add upgrade task",
    Equipment: "Operable Device",
    file: "File",
    upgrades: "Save configuration upgrade",
    Dont: "Don’t save",
    cancel: "Cancel",
    Determine: "Confirm",
    $_blacklistedScalarArgsCallback: "Create Task Successfully",
    commands: "Command sent successfully",
    connection: "Remote connection successful",
    define: "Downloading",
    DownloadEventNotifier: "Download complete",
    upgrading: "Upgrading",
    upgrade_drush_command: "Upgrade complete",
    username_last_used: "ERROR Incorrect username or password",
    tempfile: "404 file does not exist",
    Translators: "Connection timeout, unable to download",
    zxid_add_name_field: "Domain resolution error",
    DOWNLOADER_CLIENT_TLS_METHOD: "Download timeout",
    boolCheckPingURI: "MD5 check failed",
    upgrade_alter_tables: "Upgrade failed",
    keymaster_error_t: "Failed to upgrade, unknown error",
    handle_remote_sigint: "Remote connection failed",
    BAG_FILTER_EQUIPMENT: "Device is offline, try again later",
    m_upgradeThread: "Upgrade package verification failed",
    TestDelete: "Successfully deleted",
    bdb_delete: "Failed to delete",
    CompositeTask: "Delete Task",
    search1: "Search",
    search2: "Search",
    search3: "Search",
    search4: "Search",
    search5: "Search",
    KeepConfiguration: "Keep Configuration",
    Keep: "Keep",
    TaskType: "Task Type",
    UpgradeTask: "Upgrade Task",
    PatchTask: "Patch Task",
    StartingTime: "Starting Time",
    MissionDetails: "Mission Details",
    FileServer: "File Server",
    MissionAccomplished: "Mission Accomplished",
    Ongoing: "Ongoing",
    SerialNumber: "Serial Number",
    BackupServer: "Backup Server",
    DefaultServer: "Default Server",
    PrimaryServer: "Primary Server",
    checkSerialNumber: "Please check the serial number for errors",
    selectDevice: "Please select equipment",
    normalTask: "Normal Task",
    Version_NOT_SURPPORT:
      "The version is not supported. Please upgrade the device to the latest version",
    unknownError: "Unknown Error",
  },
  //任务组件
  taskDialog: {
    FutureTask: "Taskname",
    TaskStatus: "Task Description",
    completion: "Task completion status",
    group1: "Primary Group",
    group2: "Secondary Group",
    group3: "Tertiary Group",
    Equipment: "Operable Device",
    cancel: "Cancel",
    Determine: "Confirm",
    please: "Please select equipment",
    File_Upload_Upgrader: "Please select upgrade file",
    Dispatched: "operate successfully",
    operation: "Operation Failure",
    file: "file",
    provide: "Please enter task name",
    reassign_task_to: "Please enter task description",
    please: "Please select",
    fileServer: "File Server",
    TaskType: "Task Type",
    fileType: "File Type",
    fileSize: "File Size",
    deviceList: "Device Waiting List",
    deviceChecked: "Device Selection List",
    confirmCreate: "Confirm Creation Task",
    upgradeFile: "Upgrade File",
    filename: "File Name",
    toUpgrade: "To Be Upgraded List",
    filter: "Enter the serial number to filter",
  },
  //权限管理
  Authoritymanagement: {
    Add: "Add",
    Character: "Role Name",
    describe: "Description",
    statevoid: "Status",
    Creator: "Create",
    belonging: "Customer",
    Creation: "Created At",
    Operation: "Action",
    hidden: "Conceal",
    show: "Show",
    DEFINED_RIGHTS: "Permission Management",
    ANSI_PADDING: "Add Role",
    Description: "Character Description",
    cancel: "Cancel",
    Determine: "Confirm",
    mandatory: "Permission Assignment",
    functionname: "Function Name",
    m_pr_modifyS: "Successfully edited",
    onCallModifying: "Failed to edit",
    deleteDir: "Successfully deleted",
    intbdb_delete: "Failed to delete",
    Authorization: "Please select role permissions",
    localSuccess: "Successfully added",
    NewNextNotifyDT: "Failed to add",
    BoxapiJSONOperation: "Operation Failure",
    User_Role_Editor: "Template roles cannot be edited",
    addinganewrole: "Delete Role",
    normal: "Normal",
    Executing: "Please enter the added role name",
    l_vinformupdate: "Please enter the added role description",
    search1: "Search",
    search2: "Search",
    search3: "Search",
    search4: "Search",
    search5: "Search",
    search6: "Search",
    deviceManagement: "Device management"
    // SuperAdministratorRoleTemplate:'OrdinaryUserRoleTemplate',
    // CustomerAdministratorRoleTemplate:'OrdinaryUserRoleTemplate',
    // OrdinaryUserRoleTemplate:'OrdinaryUserRoleTemplate',
    // RoleTemplate:'角色模板'
  },
  //客户管理
  customermanagement: {
    Add: "Add",
    customerName: "Customer Name",
    Customer: "Customer ID",
    Admin: "Administrator",
    Contact: "Contact Person",
    phone: "Phone",
    Email: "Email",
    detailed: "Address",
    services: "Service Type",
    Operation: "Action",
    userDisplay: "User Role",
    HomeThis: "Home",
    ADDRESS: "Loaction",
    cancel: "Cancel",
    Determine: "Confirm",
    news: "Add Customer",
    CustomerAttributes: "Edit customer information",
    message1: "Successfully added",
    message2: "Insufficient permissions, add failed",
    message3: "User exists. Add Failed",
    message4: "Customer exists. Add Failed.",
    message5: "Email has been registered. Add Failed",
    message6: "Mobile phone number has been registered, add failed",
    message7: "Name exists. Add Failed.",
    message8: "Failed to add",
    message9: "Successfully deleted",
    message10: "Failed to delete. The customer cannot be deleted.",
    message11: "Failed to delete",
    message12: "Successfully edited",
    message13: "Failed to edit",
    errmessage1: "Customer name is required",
    errmessage2: "Please select a user role",
    Mage_Customer: "Delete Customer",
    Mandatory: "Required",
    specifiedwill: "Required",
    Optional: "optional",
    ServiceClient: "Standard service",
    PrintCore: "Remote printing",
    search1: "Search",
    search2: "Search",
    search3: "Search",
    search4: "Search",
    search5: "Search",
    search6: "Search",
    search7: "Search",
    search8: "Search",
    inputName: "Please enter customer name",
    selectRole: "Please select user role",
    notEdit: "No changes have been made!",
    imgFormate: "Upload your avatar only in JPG or PNG format!",
    imgSize: "The size of the uploaded profile picture should not exceed 2MB!",
    LogoFormate: "Upload Logo picture can only be JPG or PBG format!",
    LogoSize: "The size of uploaded Logo image should not exceed 2MB!",
    StandardService: "Standard Service",
    RemotePrint: "Remote Print",
    copyrightInformation: "Copyright Information",
    template: `Template: "Copyright @ 2019-2022 English Abbreviation All Rights Reserved Company Name Copyright Record Number"`
  },
  //用户管理
  usercontrol: {
    Add: "Add",
    UserGroup: "User Name",
    FILE_REAL_H: "Real Name",
    belonging: "Customer",
    bituser: "User Type",
    phone: "Phone",
    email: "Email",
    user_admin: "User Role",
    recently: "Last Login",
    Operation: "Action",
    detailed: "Detailed Information",
    userinfo: "New User Information",
    userDisplay: "Password",
    NICKNAME_RE: "Nickname",
    Gender: "Real Name",
    Male: "Male",
    Female: "Female",
    users_grid: "User Status",
    socialize: "WhatsApp/WeChat",
    email: "Email",
    address: "Address",
    notesData: "Remark",
    cancel: "Cancel",
    Determine: "Confirm",
    USER_UPDATE: "User Details",
    user_exists: "Edit User",
    change_password: "Change Password",
    New_Object: "New Password",
    changePassword: "Confirm New Password",
    errmessage1: "Username consists of any number, string, and underscore.",
    errmessage2:
      "Password consists of any number, string, underscore, and must have more than 6 digits and less than 16 digits",
    errmessage3: "User permissions are required",
    errmessage4: "User id is required",
    errmessage5: "Please enter the correct mobile phone number",
    errmessage6: "Two different passwords",
    errmessage7:
      "Password consists of any number, string, underscore, and must have more than 6 digits and less than 16 digits",
    usertype1: "Normal User",
    usertype2: "Customer Administrator",
    usertype3: "System Administrator",
    usertype4: "Super Administrator",
    message1: "successfully added",
    message2: "Email has been registered",
    message3: "Mobile phone number has been registered",
    message4: "Username has been registered",
    message5: "Failed to add",
    message6: "Successfully deleted",
    message7: "Unable to remove system superadministrator",
    message8: "Failed to delete",
    message9: "Successfully edited",
    message10: "Failed to edit",
    user_page_q_exports: "Delete User",
    Mandatory: "Required",
    Optional: "optional",
    choose: "Required",
    search1: "Search",
    search2: "Search",
    search3: "Search",
    search4: "Search",
    search5: "Search",
    search6: "Search",
    search7: "Search",
    search8: "Search",
    alarmSetting: "Alarm Setting",
    monitorSetting: "Cloud Monitor",
    monitorTips: "Are you sure cloud monitoring is enabled?",
    monitorCloseTips: "Confirm that cloud monitoring is off?",
    alarmTips: "Confirm to turn on the device offline alarm reminder?",
    alarmCloseTips: "Confirm to turn off the device offline alarm reminder?",
    selectRoleTips: "Please select the user role",
    selectCustomerTips: "Please select user identity",
    selectTelTips: "Please fill in your contact number",
    selectEmailTips: "Please fill in your Email",
  },
  // 参数管理
  parameter: {
    name: "Name",
    description: "Description",
    value: "Value",
    time: "Add/Edit Time",
    chineseName: "Parameter Chinese name duplicate",
    englishName: "The English name of the parameter is repeated",
  },
  //删除弹出框
  DeleteBox: {
    prompt: "Prompt",
    Tetx:
      "This action will permanently delete the data. Do you want to continue?",
    confirmButtonText: "Confirm",
    cancelButtonText: "Cancel",
  },
  // n2n
  n2n: {
    serverName: "Server Name",
    version: "Software version",
    port: "Port",
    totalGroups: "Total Groups",
    totaldevices: "Total Devices",
    createTime: "Create Time",
    groupManagement: "N2N Group Management",
    groupInfo: "Group Info",
    groupName: "Group Name",
    customer: "Belong Customer",
    username: "Remote Username",
    password: "Remote Password",
    ip: "Remote IP",
    remotePort: "Remote Port",
    deivceNumber: "Deivce Number",
    migrate: "Migrate",
    target: "Target Server",
    original: "Original Server",
    originalN2N: "Original N2N",
    targetN2N: "Target N2N",
    confirmTips:
      "This action will modify the packet N2N service. Do you want to continue?",
    groupComfirm:
      "This operation will modify all groups under the N2N. Do you want to continue?",
    inputEmpty: "Cannot be empty",
    versionEmpty: "N2n version cannot be empty",
    versionInt: "N2n version can only be integer",
    portRang: "Please input port from 9001 to 50000",
    serverEmpty: "Service name cannot be empty",
    serverAddressEmpty: "Server address cannot be empty",
    portRepeat: "Duplicate port number",
    PresenceDevice: "There are devices under n2n",
    PresenceGroup: "There are groups under n2n",
    deleteN2n:
      "Deleting the N2N service will invalidate the remote functionality of all devices under the service. Are you sure you want to delete?",
    serverAddress: "Server Address",
    groupAutomaticDistribution: "Group Automatic Distribution",
    inputGroupName: "remote account",
    groupTips: "After checking this option, when creating a group, the service will be automatically assigned to the new group",
    queryTeam: "(Query the service to which the account belongs)",
  },
  xlsx: {
    export: "Export",
  },
  // 下挂设备
  HangingDevice: {
    alias: "Printer Name",
    vendor: "Printer Supplier",
    type: "Printer Type",
    status: "Printer Status",
    lastts: "Last Print Time",
    did: "Print Server DID",
    dsn: "Print Server SerialNumber",
    printeMethod: "Print Method",
    port: "Port",
    serialNumber: "Serial Number",
    edit: "Edit",
    offline: "Disconnected",
    online: "Connected",
    Description: "Description",
    successNumber: "Number of printing success",
    failNumber: "Number of print failures",
    totalNumber: "Total number of prints",
    finalTime: "Last print time",
  },
  // 打印驱动管理
  PrinterDriver: {
    printDrive: "Printer Address",
    printType: "Printer Type",
    printDriveSearch: "Search By Printer Address",
    printTypeSearch: "Search By Printer Type",
    driveSign: "Driver Sign",
    common: "Common",
    special: "Special",
    debugFlag: "Debug Flag",
    notDebugging: "Not Debugging",
    debuggingThrough: "Debugging Through",
    debuggingFailed: "Debugging Failed",
    printTypeInput: "Please input the ptinter type",
    driveSignSelect: "Please select the driver sign",
    debugFlagSelect: "Please select the debug flag",
    printDriveInput: "Please input the printer driver address",
    remark: "Remark",
    remarkInput: "Please input the printer driver remark",
  },
  /**
 * 云监测
 */
  // 报警通知
  Confirm: {
    SuccessfullyDelete: "Delete Successfully",
    DeleteFailed: "Delete failed, please try again!",
    SuccessfullyAdd: "Add Successfully",
    AddFailed: "Add failed, please try again",
    SuccessfullyEdit: "Edit Successfully",
    EditFailed: "Edit failed, please try again",
  },
  Input: {
    placeholder: "Please Select",
    inputPlaceholder: "Please Input",
  },
  /**
   * 云监测
   */
  // 监控大屏
  Monitor: {
    MonitorScreen: "Monitor Screen",
    systemOverview: "System Overview",
    deviceConfiguration: "Device Configuration",
    deviceOverview: "Device Overview",
    deviceTotalNumber: "Total Number",
    totalOffline: "Total Offline",
    totalOnline: "Total Online",
    deviceList: "Device List",
    deviceSearch: "SN/Name",
    disconnected: "Disconnected",
    connected: "Connected",
    alarmStatistics: "Alarm Statistics",
    todayTotalNumber: "Today Total Number",
    todayProcessedNumber: "Today Processed Number",
    todayUnprocessedNumber: "Today Unprocessed Number",
    alarmInfo: "Alarm Info",
    alarmHandling: "Alarm Handling",
    alarmStartTime: "Alarm Start Time",
    alarmEndTime: "Alarm End Time",
    alarmResult: "Alarm Result",
    Unprocessed: "Unprocessed",
    Processed: "Processed",
    ProcessingDescription: "Processing Description",
    device: "Device",
    terminal: "Terminal",
    variable: "Variable",
    content: "Content",
    deviceInfo: "Device Info",
    historyData: "History Data",
    historyAlarm: "History Alarm",
    deviceName: "Device Name",
    deviceAddress: "Device Address",
    project: "Project",
    terminalName: "Terminal Name",
    setVariable: "Set Variable",
    to: "to",
    search: "Search",
    export: "export",
    addedVariable: "Added Variable",
    realTimeAlarm: "Real-Time Alarm Data",
    realTimeMonitoring: "real time monitoring",
    realTimeMonitoring: 'Real-time terminal data',
    pleaseTerminal: "Please select a terminal",
    pleaseVariable: 'Please select a variable',
    Pleasetime: "Please select a time",
    Open: "Open",
    Close: "Close",
    collectionTime: "Collection Time",
    pleaseModifyValu: "Please enter a modified value",
    loading: "Loading...",
    setValue: "Set Value",
    noData: "No datas found. Please check your item!"
  },
  // 快速接入
  FastAccess: {
    addProject: "Add Project",
    addDevice: "Add Device",
    addTerminal: "Add Terminal",
    addTemplate: "Collect Configuration",
    startCollecting: "Start Collecting",
    projectName: "Project Name",
    deviceSn: "Device Serial Number",
    terminalName: "Terminal Name",
    projectTips1: "Your project is",
    projectTips2: "details can be found in the project list",
    deviceTips1: "Your device is",
    deviceTips2: "details can be found in the device list",
    terminalTips1: "Your terminal is",
    terminalTips2: "details can be found in the terminal list",
    continueAdd: "Continue To Add",
    successTips: "You have successfully operated!",
    BelogingUser: "Beloging User",
    ownCustomer: "OwnCustomer",
    projectType: "Project type",
    selectProject: "Select an existing project",
    genericType: "generic type",
    pleaseName: "Please enter a name",
    pleasecustomer: "Please select a customer",
    pleaseProject: "Please select the client for the project",
    firstGrouping: "First-level grouping：",
    next: "Next step",
    backNewProject: "Back to New Project",
    levelGrouping: "Project level grouping：",
    secondaryGrouping: "Project secondary grouping",
    previous: "Previous",
    NewTemplate: "New Collection Template",
    IssueCollection: "trigger collection",
    ConfirmAdd: "Confirm Add",
    pleaseTname: "Please enter a template name",
    selectedCollection: "Please enter the selected collection method",
    collectionTemplate: "Existing collection template",
    warning1: "There are still variables that have not been issued with the collection command, please issue the collection command first!",
    Failedtoadddevice: "Failed to add device",
    tryagain: "Request failed, please try again",
    pleasechooseanother: "This device is not connected, please choose another device!",
    Failedtoeditgroup: "Failed to edit group",
    Failedtoaddgroup: "Failed to add group",
    Commandissuedsuccessfully: "Command issued successfully",
    variablesfirst: "Please add variables first!",
    variablelist: "Failed to get variable list!",
    configurationfailed: "Terminal serial port configuration failed!",
    terminalcommands: "Failed to send terminal commands!",
    Failedtoaddterminal: "Failed to add terminal"
  },
  // 变量列表
  variableList: {
    seriableNumber: "Seriable Number",
    name: "Name",
    unit: "Unit",
    registerMode: "Register Mode",
    registerAddress: "Register Address",
    dataType: "Data Type",
    byteOrder: "Byte Order",
    triggerType: "Trigger Type",
    triggerPeriod: "Trigger Period",
    calculationFactor: "Calculation Factor",
    decimalPrecision: "Decimal Precision",
    setThreshold: "Set Threshold",
    minimum: 'minimum',
    maximum: 'maximum value',
    value: 'value',
  },
  // 设备管理
  devicesManagement: {
    FastAccess: "Fast Access",
    ProjectGroup: "Project List",
    TerminalList: "Terminal List",
    CollectConfigurate: "Collect Configuration",
    EditCollection: "Add Variable",
    AddDevice: "Add Devices",
    AddTerminal: "Add Terminal",
    deviceList: "Device List",
    variableList: "Variable List",
    addATemplate: "Add A Template",
    editATemplate: "Edit A Template",
    Noprojectgroups: "No project groups and devices selected!",
    Nodeviceselected: "No device selected!",
    Noprojectgroup: "No project group selected!",
    Addedsuccessfully: "Added successfully!",
    webssh: "Remote Terminal"
  },
  // 项目列表
  projectList: {
    name: "Name",
    BelogingCustomer: "Beloging Customer",
    creator: "Creator",
    createTime: "Create Time",
    AddProject: "Add Project",
    EditProject: "Edit Project",
    FirstProjectGroup: "First Project Group",
    BelogingUser: "Beloging User",
    projectType: "Project Type",
    generictype: 'generic type',
    confirmdeletion: 'confirm deletion',
    cannotbedeleted: "The project group exists in the device and cannot be deleted!"
  },
  // 报警管理类
  alarmManagement: {
    alarmManagement: "Alarm Management",
    AlarmNotice: "Alarm Notice",
    AlarmContact: "Alarm Contact",
    AlarmList: "Alarm Records",
  },
  // 报警通知
  alarmNotice: {
    device: "Device",
    terminal: "Terminal",
    variable: "Variable",
    alarmContent: "Alarm Content",
    alarmStartTime: "Alarm Start Time",
    alarmEndTime: "Alarm End Time",
    triggering: "Triggering conditions",
    enable: "Enable",
    disabled: "Disabled",
    add: "Add to",
    serialNumber: "Serial number",
    eventName: "Event name",
    way: "Way",
    information1: "Notification information (alarm)",
    information2: "Notification information (recovery)",
    tsn: "Terminal SN (name)",
    pushMechanism: "Push mechanism",
    once: "Once",
    repeatedly: "Repeatedly",
    state: "State",
    AlarmContact: "Alarm contact",
    operate: "operate",
    EditingAlarm: "Editing Alarm Notifications",
    Addalarm: "Add alarm",
    email: "Email",
    Alarmterminal: 'Alarm terminal',
    timeInterval: "time interval",
    minute: "minute",
    msg1: "Please enter the alarm notification name",
    msg2: "Please select an alarm method",
    msg3: "Please select an alarm terminal and an alarm contact!",
    msg4: "Please select an alarm terminal!",
    msg5: 'Please select an alarm contact! ',
    msg6: 'Modification succeeded! ',
    msg7: 'The modification failed, please try again! ',
    msg8: 'Added successfully! ',
    msg9: 'Add failed, please try again! ',
    pleaseChoose: 'please choose',
    Alarmoperate: 'Alarm operate',
    numberValue: "Numerical value",
    Newcontact: "New contact"
  },
  // 统计报表
  statictics: {
    HistoryRecords: "History Records",
    DevicesStatus: "Devices Status",
  },
  Button: {
    Add: "Add",
    submit: "Submit",
    confirm: "Confirm",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    operation: "Operation",
    tips: "Tips",
    isDelete: "Sure to delete?",
    successDelete: "successfully delete!",
    failDelete: "Delete failed",
    successEdit: "Successfully edit!",
    failEdit: "Edit failed",
    successSetting: "Successfully Setting! ",
    failSetting: "Setting failed!",
    successOperation: "Operation successful!",
    failOperation: "Operation failed, please try again!",
    successConfiguration: "Configuration is successful",
    failConfiguration: "Configuration failed",
    successAdd: "Successfully add!",
    failAdd: "Add failed!",
    refresh: 'Refresh server address',
  },
  // 顶部导航
  navTab: {
    devicesManagement: "Devices Management",
    monitorCloud: "Cloud Monitoring",
  },
  //切卡记录
  switchCrad: {
    switchCradRecord: "switch card record",
    startDate: "start date",
    endDate: "end date",
    Inquire: "Inquire",
    serialNumber: "serial number",
    OperatorFront: "Operator (front)",
    ViewChekaRecords: "View Cheka Records",
    ICCIDFront: "ICCID (front)",
    SignalFront: "Signal (front)",
    operatorRear: "operator (rear)",
    ICCIDRear: "ICCID (rear)",
    SignalRear: "Signal rear",
    ChekaTime: "Cheka time",
    Cancel: "Cancel",
  },
  //上下线记录
  onAndOf: {
    OnlineAndOfflineRecords: "online and offline records",
    time: "Time",
    type: "Type",
    offline: "offline",
    online: "online",
    all: "all",
    GetFailed: "Get failed!",
    repair: "equipment repair"
  },
  //变量列表
  varlist: {
    terminalType: "Terminal type",
    ReturnToTerminalList: "Return to terminal list",
    Inquire: "Inquire",
    PleaseEnterVariableName: "Please enter variable name",
    terminalName: "Terminal name",
    aName: "Please enter a name",
    varNmae: "Variable name",
    Selectendian: "Select endian",
    Choosereporttype: "Choose report type",
    controltype: "Control type",
    precision: "Precision",
    Selectdatatype: "Select data type",
    maximumvalue: "Please enter the maximum value",
    minimumValue: "Please enter a minimum value",
    confirm1: "This operation will permanently delete the data, whether to continue?",
    variabletype: "Threshold cannot be set for this variable type",
    sendcollection: "Failed to send collection!",
    ActionThresholdFailed: "Action Threshold Failed!",
    viewterminal: "view terminal"
  },
  //终端列表
  terminalList: {
    add: "Add to",
    name: 'Name',
    serialNumber: 'Serial Number',
    templateName: 'Template name',
    protocol: 'Protocol',
    describe: 'Describe',
    Edittheterminaldevice: "Edit Terminal Device",
    Addaterminaldevice: "Add Terminal Device",
    Fillintheterminalinformation: "Fill in terminal information",
    Collectionconfigurationtemplate: "Collection Configuration Template",
    Templatecategory: "Template Category",
    Protocol: "Agreement",
    Equipment: "Owned Equipment",
    Name: "Name",
    SlaveID: "Slave station ID",
    Valuerange: "Range of Values：0~",
    Slaveaddress: "Slave Address",
    Port: "Port",
    SerialportNo: "Device serial number",
    Pleaseselecttheequipmentfirst: "Please select your device first",
    Configureserialportinformation: "Configure Serial Port Information",
    Cancel: "Cancel",
    Confirm: "Confirmation",
    Successfullymodified: "Modified successfully!",
    Successfullyadded: "Successfully added!",
    Requestfailed: 'Request failed',
    Serialportconfigurationfailed: 'Serial port configuration failed!',
    Failedtoissuethecommand: "Failed to issue the command!",
    Collectionfailed: "The terminal information collection failed, please confirm the terminal basic information parameters!",
    Collectionrequesterror: "Terminal information collection request error!",
    Modificationfailed: 'Modification failed, please try again!',
    Addingfailed: 'Adding failed, please try again!',
    Notselected: "No device selected",
    Incorrectfilling: "The terminal information is not filled in correctly!",
    NewTemplate: "New Collection Template",
    IssueCollection: "trigger collection",
    ConfirmAdd: "Confirm add",
    form1: "Please select a collection configuration template",
    form2: "Please select the device",
    form3: 'Please enter the slave ID',
    form4: "Cannot be negative",
    form5: "Slave ID value range: 0~",
    form6: "Please enter the slave address",
    form7: "Slave address input error",
    form8: "Port number error",
    form9: "Please enter the terminal name",
    form10: "No data",
    form11: "Please select a terminal protocol",
    form12: "Port number does not match",
    Basicinformation: "Basic information of terminal equipment",
    Protocolinformation: "Protocol information",
    TerminalDetails: "Terminal Equipment Details",
    details: "Details",
    returntodevicelist: "return to device list",
    Terminalinformation: "Terminal information collection error, please check the terminal information parameters!",
    collectionrequesterror: "Terminal information collection request error!",
    hiddenTerminal: 'hidden terminal',
    nohiddenTerminal: 'non-hidden terminal',
    terminalNumber: 'terminal number',
    monitoringLocation: "monitoring location",
    accessTime: "access time",
    showDetail: 'Whether to hide this terminal',
    tip: "Tip",
    copySuccess: "Copy success",
    copyFail: "Copy failed",
    deleteDetail: "Whether to delete this terminal",
    refresh: 'Refresh',
    plsupdate: 'This service does not support automatic refresh. Please click the refresh button manually to update data',
    index: 'Serial number',
    ip: "IP address",
    mac: 'MAC address',
    networkInterface: 'Network interface',
    operate: 'Operation',
    directAccess: 'Direct access',
    configAccess: 'Configure access',
    connectTips: 'Connection tips',
    stopClose: 'Please do not close this window. Closing it will be considered a disconnection!',
    portToAccess: 'Port to access',
    urlToAccess: 'Path to access',
    EstablishConnection: 'Establish connection',
  },
  //采集配置
  collect: {
    templateName: 'Template name',
    TemplateType: 'Template type',
    Updateddate: 'Updated date',
    TemplateInformation: "Template information",
    save: "Save",
    variableInformation: "variable information",
    PleaseSave: "Please save the template information before adding variables",
    IssueCollection: "Trigger collection",
    Cancel: "Cancel",
    describe: "Describe",
    addVariable: "Add variable",
    serialNumber: "Serial number",
    variableName: "Variable name",
    unit: "Unit",
    registertype: "Register type",
    startaddress: "Register start address",
    typeofdata: "Type of data",
    endian: 'Endian',
    Reportingtype: 'Reporting type',
    Reportingcycle: 'Reporting cycle',
    second: 'second',
    calculationfactor: 'Calculation factor',
    decimalprecision: 'Decimal precision',
    IOcontrollertype: 'IO controller type',
    interfacenumber: 'Interface number',
    functiontype: 'Function type',
    operate: 'Operate',
    msg1: 'This operation will permanently delete the data, do you want to continue?',
    msg2: 'Prompt',
    msg3: 'Confirm',
    msg4: 'Deletion successful! ',
    msg5: 'The command was issued successfully! ',
    msg6: 'The command failed, please try again! ',
    msg7: 'This variable is performing a collection task, please stop and then delete it! ',
    msg8: 'Deletion failed, please try again! ',
    msg9: 'Please select a collection template! ',
    msg10: "The form information is not filled out correctly!",
    msg11: "The modified template is being used by a terminal and cannot be deleted",
    setalarm: 'set alarm',
    Callthepolice: "Call the police：",
    Triggeringconditions: "Triggering conditions：",
    PleasevalueA: "Please enter the value A",
    PleasevalueB: "Please enter value B",
    Alarmpushcontent: "Alarm push content:",
    Restorepushcontent: "Restore push content:",
    SwitchOFF: "switch OFF",
    switchON: "switch ON",
    valuelessA: "value less than A",
    valuegreaterB: "value greater than B",
    ValuegreaterAlessB: 'Value greater than A and less than B',
    ValuelessAgreaterB: "Value less than A or value greater than B",
    valueisequaltoA: "value is equal to A",
    Failedtoobtain: "Failed to obtain alarm rules!",
    Setupsucceeded: 'Setup succeeded',
    Setupfailed: 'Setup failed, please try again',
    Savefailed: "Save failed, please try again!",
    pleaseTcontent: 'Please enter the alarm push content'
  },
  //编辑变量
  editVar: {
    Editvariables: 'Edit variables',
    addvariable: 'Add variable',
    type: 'Type',
    rawtype: 'Read and write type',
    variableunit: 'Variable unit',
    inputrange: 'Input range: 0~65535',
    typedata: 'Type of data',
    reportingperiod: 'Please enter the reporting period',
    calculationfactor: 'Please enter a calculation factor',
    decimalprecision: 'Decimal precision',
    msg1: 'Please enter a calculation factor, which cannot be 0',
    msg2: 'The calculation factor cannot be 0',
    msg3: "Calculation factors can only be numbers",
    msg4: 'Register address error, input range: 0~65535',
    msg5: 'Please select the function type',
    msg6: 'Please enter the variable name',
    msg7: 'Please select the register type',
    msg8: 'Please select a variable type',
    msg9: 'Please enter the variable unit',
    msg10: 'The range can only be between 0~65535',
    msg11: 'Please enter variable decimal precision',
    msg12: 'Please select a data type',
    msg13: 'Please select an endian',
    msg14: 'Please select the report type',
    msg15: 'Please enter the reporting period',
    msg16: 'Please enter the interface number',
    msg30: 'Please enter the correct sid',
    relay1: 'relay1',
    relay2: 'relay2',
    bool: "Boolean（bool）",
    readandwrite: 'Read and write',
    read: 'Read only',
    msg17: 'Modification succeeded! ',
    msg18: 'Modification failed, please try again! ',
    msg19: 'Added successfully! ',
    msg20: 'Add failed, please try again! ',
    msg21: 'Enter a custom value',
    msg22: 'Prompt',
    msg23: 'OK',
    msg24: 'Cancel',
    msg25: 'Can only be numbers',
    msg26: 'Custom',
    msg27: 'Cancel input',
    msg28: "Amount cannot modify value",
    Pleaseentertheunit: "Please enter the unit",
    msg28: "unit length too long",
    msg29: "Unit cannot be empty",
    pleaseEnterAValidValue: "Please enter a valid value",
    pleaseEnterInt32: "Please enter an integer between -2147483648 and 2147483647",
    pleaseEnterUint32: "Please enter an integer between 0 and 4294967295",
  },
  smartcat: {

  },
  openvpn: {
    name: "Name",
    recipe: "Mode",
    enabled: "Enable",
    open: "Open",
    close: "no",
    port: "Port",
    proto: "Protocol",
    status: "Started",
    yes: "Yes",
    no: "No",
    constatus: "Status",
    start_stop: "Start/Stop",
    start: "start",
    stop: "stop",
    operate: "Operation",
    edit: "Edit",
    noConnect: "Disconnect",
    connecting: "connecting",
    actionOk: "Startup successful",
    stopOk: "Successfully paused",
    configuration: "Configuration",
    tips1: "Set output verbosity",
    tips2: "TCP/UDP port # for both local and remote",
    tips3: "Make run device IPv6 capable",
    tips4: "Use device type",
    tips5: "Configure server mode",
    tips6: "Configure server bridge",
    tips7: "Do not bind the local address and port",
    tips8: "Encrypted data packets",
    tips9: "Use fast LZO compression",
    tips10: "Use the compression option on version 2.4+",
    tips11: "Helper directive to simplify the expression of --ping and --ping-restart in server mode configurations",
    tips12: "Use protocol",
    tips13: "Configure client mode",
    tips14: "Remote hostname or ip address",
    tips15: "Authentication method, use ca certificate authentication by default",
    tips16: "Verify by username/password",
    tips17: "Select file",
    tips18: "secret allows static key encryption mode",
    tips19: "cert local certificate in PEM format",
    tips20: "The key contained in the PKCS#12 file",
    tips21: "Diffie-Hellman/DH key exchange parameters",
    tips22: "Local private key",
    tips23: "TLS encryption key",
    tips24: "dev tun/tap device",
    addSelect: "Add",
    saveEdit: "Save",
    moreSelect: "-- More options --",
    selected: "chosen",
    noFile: "No related documents",
    verb: "verb",
    port: "port",
    changeProcessPriority: "change process priority",
    proto: "proto",
    client: "client",
    remote: "remote",
    keepalive: "keepalive",
    comp_lzo: "comp_lzo",
    compress: "compress",
    cipher: "cipher",
    nobind: "nobind",
    tun_ipv6: "tun-ipv6",
    nice: "nice",
    server: "server",
    server_bridge: "server_bridge",
    dev_type: "dev-type",
    auth_method: "auth-method",
    auth: "auth",
    username: "username",
    password: "password",
    secret: "secret",
    pkcs12: "pkcs12",
    ca: "ca",
    dh: "dh",
    cert: "cert",
    key: "key",
    tls_crypt: 'tls_crypt',
    authParameter: "auth parameter",
    useStaticKeys: "use static keys",
    addtlsauth: 'add tls-auth configuration',
    enabletlsauth: 'enable tls-auth',
    tlsAuth: 'tls-auth',
    enableDh: "enable dh",
    addDh: "add dh configuration",
    enablePkcs: "enable pkcs12",
    addPkcs: "add pkcs12 configuration",
    enabletlscrypt: 'enable tls-crypt',
    addtlscrypt: 'add tls-crypt configuration',
    cacert: 'ca cert',
    username2: 'username',
    usernameCacert: 'username+ca cert',
    dev: "dev",
  },
  repeater: {
    refsh: "Refresh",
    universal: "universal",
    serverConfig: "Server Configuration",
    enable: "Enable",
    operatingModel: "Working Mode",
    protocol: 'Protocol',
    serverAddress: "Server",
    heartbeatCycle: "Heartbeat Period",
    second: "Seconds",
    state: "Status",
    noConnect: "Not Connected",
    connectNumber: "Conns",
    relayConfig: "Relay Configuration",
    reportTerminal: "Upload Tem",
    name: "Name",
    listenPort: "Listen Port",
    sendTo: "Send to",
    ipRules: "IP1:port IP2port2...#Multiple ip:ports are separated by spaces",
    del: "Delete",
    add: "Add",
    serailConfig: "Serial configuration",
    interface: "Interface",
    baudrate: "Baud rate",
    data_bits: "Data Bits",
    stop_bits: "Stop Bits",
    parity: "Parity",
    flow: "Llow Control",
    edit: "Edit",
    adv: "Advanced",
    advConfig: "Advanced Configuration",
    trueOn: "Enable",
    debug: "Debug",
    tcpKeep: "TCP keepalive idle Time",
    tcpKeep2: "TCP Keepalive interval",
    tcpKeep3: "TCP Max keepalive Probe",
    logNumber: "Log File Num",
    logSize: "Log file size",
    logPriority: "Log Priority",
    info: "Info",
    notice: "Notice",
    warn: "Warning",
    error: "Error",
    fatal: "Critical",
    alert: "Alert",
    urgent: "Emergency",
    logFile: "log file",
    download: "download",
    SaveApply: "Save and Apply",
    numberRuleErr: "Please enter the correct value",
    ipRuleErr: "The ip address is invalid",
    portRuleErr: "The port number is incorrect",
    nameRuleErr1: "This name exists",
    nameRuleErr2: "Between 0~31",
    heartbeatRuleErr: "Please enter the heartbeat cycle",
    numberRuleErr2: "Please enter a name",
    tcpRuleErr: "Please enter the TCP keep-alive idle time",
    tcpRuleErr2: "Please enter the TCP keep-alive detection interval",
    tcpRuleErr3: "Please enter the maximum number of TCP keepalive probes",
    logRuleErr: "Please enter the number of log files to keep",
    logRuleErr2: "Please enter the log file size",
    saveSuccess: "Save successfully",
    seniorErr: "The advanced configuration form is not complete",
    serverErr: "The server configuration parameters are incorrect",
    repeaterErr: "The repeater configuration is not perfect",
    repeaterErr2: "The device has no repeater configuration",
    sec: "sec"
  },
  IOControl: {
    universal: "universal",
    DIDigitalInput: "DI Digital Input",
    deviceName: "Device Name",
    pleaseDeviceName: "Please enter the device name",
    interfaceName: "Interface Name",
    deviceState: "Device State",
    DODigitalInput: "DO digital output",
    start_stop: "Start/Stop",
    close: "close",
    open: "Open",
    relay: "Relay",
    senior: "senior",
    seniorConfig: "Advanced Configuration",
    trueOn: "On",
    debug: "Debug",
    info: "Information",
    notice: "Attention",
    warn: "Warning",
    error: "Error",
    fatal: "fatal",
    alert: "Alert",
    urgent: "urgent",
    logNumber: "Number of log files to keep",
    logSize: "Log file size",
    logPriority: "Log Priority",
    logFile: "Log File",
    download: "Download",
    SaveApply: "Save and Apply",
    enable: "Enable",
    editSuccess: "Modified successfully",
    refresh: "refresh",
    msgok: "Operation succeeded",
    msgfaile: "operation failed",
    disable: "Disable",
    msg1: "Please turn it on first"
  },
  unit: {
    registerTypeObj1: "Read Coil",
    registerTypeObj2: "Read input state",
    registerTypeObj3: "Read Holding Register",
    registerTypeObj4: "Read Input Register",
    dataFormatObj1: "16-bit unsigned",
    dataFormatObj2: "16-bit signed",
    dataFormatObj3: "16-bit BCD",
    dataFormatObj4: "32-bit unsigned (AB CD)",
    dataFormatObj5: "32-bit unsigned (CD AB)",
    dataFormatObj6: "32-bit signed (AB CD)",
    dataFormatObj7: "32-bit signed (CD AB)",
    dataFormatObj8: "32-bit float (AB CD)",
    dataFormatObj9: "32-bit float (CD AB)",
    dataFormatObj10: "32-bit float (CD AB)",
    dataFormatObj11: "32-bit BCD",
    dataFormatObj12: "32-bit BCD",
    dataFormatObj13: "bit",
    dataFormatObj14: "32-bit timestamp",
    dataFormatObj15: "32-bit timestamp",
    ioControlListObj0: "Generic",
    ioControlListObj1: "Fan",
    ioControlListObj2: "Light and sound alarm",
    ioControlListObj3: "Smoke Alarm",
    modbusListObj0: "Universal",
    modbusListObj1: "Temperature",
    modbusListObj2: "Humidity",
    typeListObj0: "Modbus",
    typeListObj1: "IO Control",
    dataTypeObj1: "16-bit signed (int16)",
    dataTypeObj2: "16-bit unsigned (uint16)",
    dataTypeObj3: "32-bit signed (int32)",
    dataTypeObj4: "32-bit unsigned (uint32)",
    dataTypeObj5: "64-bit signed (int64)",
    dataTypeObj6: "64-bit unsigned (uint64)",
    dataTypeObj7: "Floating point single precision (float)",
    dataTypeObj8: "Floating point double precision (double)",
    dataTypeObj9: "String (string)",
    dataTypeObj10: "Boolean (bool)",
    dataTypeObj11: "Custom",
    dataTypeObj12: "Time type（int64）",
    dataTypeObj13: "raw",
    endianObj1: "Endian Byte Order (ABCD)",
    endianObj2: "Little Endian Byte Order (CDAB)",
    triggerObj2: "Periodic report",
    triggerObj3: "Status Change",
    triggerObj4: "Never report",
    storageModeObj1: "Change Storage",
    storageModeObj2: "All Storage",
    rorwObj1: "Read only",
    rorwObj2: "Write only",
    unitObj1: "Celsius (°C)",
    unitObj2: "Pa (Pa)",
    unitObj3: "volt",
    unitObj4: "Percent (%)",
    unitObj5: "mA (mA)",
    unitObj6: "Ohm(R)",
    unitObj7: "None",
    registerTypeOptions1: "1(coil status)",
    registerTypeOptions2: "2(input state)",
    registerTypeOptions3: "3(holding register)",
    registerTypeOptions4: "4(input register)",
  },
  //报警记录
  alarmList: {
    serialNumber: 'Serial number',
    devicename: "Device name",
    terminalname: "Terminal name",
    variable: "Variable",
    currentvalue: "The current value",
    Triggeringconditions: "Triggering conditions",
    Notificationinformation: "Notification information (alarm)",
    Notificationinformation2: "Notification Information (Recovery)",
    starttime: 'Alarm start time',
    endtime: "Alarm end time",
    Alarmstatus: "Alarm status",
    restored: "Restored",
    inalarm: "In Alarm",
    operate: "Operate",
    Handlingalarms: 'Handling alarms',
    ProcessDescription: "Process description"
  },
  //报警联系人
  alarmContact: {
    name: "Name",
    phone: "Phone number",
    email: "Email",
    wechat: "Wechat",
    Remark: 'Remark',
    add: "Add to",
    EditContact: 'Edit Contact',
    Addcontacts: "Add contacts",
    new: "New",
    msg1: "Please fill in the phone number",
    msg2: "Please fill in the email address",
    msg3: "Please enter your name",
    msg4: "The phone number already exists!",
    msg5: 'The phone number format is incorrect',
    msg6: 'The mailbox already exists! ',
    msg7: 'Modification succeeded! ',
    msg8: 'The modification failed, please try again! ',
    msg9: 'Added successfully! ',
    msg10: 'Add failed, please try again! ',
    wxandemail: 'Wechat、Email',
    Shortmessage: 'Short message',
    Emaildoesnot: "Email does not match the format"
  },
  rightAlarm: {
    Nopermission: 'No permission',
    Alarmhandling: 'Alarm handling',
    Alarmstart: 'Alarm start time:',
    Alarmend: 'Alarm end time:',
    Alarmresult: 'Alarm result:',
    notprocessed: 'not processed',
    Processing: 'Processing description:',
    save: 'Save',
    equipment: 'equipment:',
    terminal: 'terminal:',
    variable: 'variable:',
    content: 'content:',
    msg1: 'Save successfully! ',
    msg2: 'Save failed! ',
    msg3: 'The request failed, please try again! '
  },
  networkMonitoring: {
    configuration: "Configuration",
    enabled: "Enabled",
    operatingMode: "Operating Mode",
    pleaseChoose: "Please choose",
    restartAfterNetworkDisconnection: "Restart after network disconnection",
    periodicRestart: "Periodic restart",
    detectionAddress: "Detection Address",
    pleaseEnter: "Please enter",
    detectionCycle: "Detection Cycle",
    recoveryPeriod: "Recovery Period",
    tips1: "The frequency of detecting network connections, in seconds",
    tips2: "The default unit is seconds, you can use 'm' as suffix for minutes, 'h' for hours and 'd' for days.",
    save: "Save",
    msg1: "Failed to get data!",
    msg2: "Successfully saved",
    msg3: "Save failed!",
    msg4: "Please fill out the correct form",
    repeatCycle: "Repeat Cycle",
  },
  //智慧电梯
  smartele: {
    updateInterval: "Please fill in the correct update interval",
    log_file_num: "Please fill in the correct number of log files",
    log_file_size: "Please fill in the correct log file size",
    server: "Server",
    customerID: "Customer ID",
    MQTTQualityofService: "MQTT Quality of Service",
    sessionCleanup: "Session Cleanup",
    keepInformation: "Keep Information",
    policyConfiguration: "Policy Configuration",
    EscalationPolicy: "Escalation Policy",
    ReportRegularly: "Report Regularly",
    ChangeReporting: "Change Reporting",
    ReportAllAttributes: "Report All Attributes",
    NonFullAttributeReporting: 'Non-full attribute reporting',
    speed: "Speed",
    ValueMethod: "Value Method",
    averageValue: "Average Value",
    instantaneousValue: "Instantaneous Value",
    timeInterval: "Time Interval",
    ReportingThreshold: "Reporting Threshold",
    acceleration: "Acceleration",
    barometricPressure: "Barometric Pressure",
    TheSamplingPeriod: "The Sampling Period",
    floatingValue: "Floating Value",
    NumberOfFloats: "Number Of Floats",
    high: "High",
    temperature: "Temperature",
    humidity: "Humidity",
    DirectionOfMovement: "Direction Of Movement",
    motionTOstill: "motion -> still",
    stillToMoving: "still -> moving",
    doorStatus: "Door Status",
    notClosedToClosed: "not closed -> closed",
    closedToNotClosed: "closed -> not closed",
    flatState: "Flat State",
    NonFlatLayerToFlatLayer: "Non-flat layer -> flat layer",
    FlatLayerToNonFlatLayer: "Flat layer -> non-flat layer",
    GrassrootsState: "Grassroots State",
    NonGrassrootsToGrassroots: "Non-grassroots -> grassroots",
    GrassrootsToNonGrassroots: "Grassroots -> non-grassroots",
    PersonnelStatus: "Personnel Status",
    noOneToSomeone: "no one -> someone",
    someoneToNoOne: "someone -> no one",
    SerialPortConfiguration: "Serial Port Configuration",
    DataUpdateCycle: "Data Update Cycle",
    errorMsg: "Please enter correct value",
    LOGOFacingUp: "LOGO Facing Up",
    toward: "Toward",
    lightUp: "Light up",
  },
  // sms短信
  smartsms: {
    configuration: "Configuration",
    inbox: "Inbox",
    oubox: "Oubox",
    advanced: "Advanced",
    mobileNetwork: "Mobile Network",
    SIM1Number: "SIM1 Number",
    storageLocation: "Storage Location",
    SIMCard: "SIM Card",
    equipmentTerminal: "Equipment Terminal",
    SMSCenter: "SMS Center",
    tips1: "International area code + mobile phone number, such as 861380013800",
    whitelist: "Whitelist",
    validityPeriod: "Validity Period",
    DetectionCycle: "Detection Cycle",
    saveAndApply: "Save and Apply",
    overview: "Overview",
    thresholdManagement: "Threshold Management",
    storeState: "Store State",
    CurrentSIMCard: "Current SIM card",
    messageList: "Message List",
    serialNumber: "Serial Number",
    telephoneNumber: "Telephone Number",
    SMSContent: "SMS Content",
    date: "Date",
    merge: "Merge",
    no: "No",
    yes: "Yes",
    delete: "Delete",
    tips2: "This action will permanently delete the message, do you want to continue?",
    tips: "Tips",
    sure: "Sure",
    cancel: "Cancel",
    state: "State",
    edit: "Edit",
    send: "Send",
    tips3: "The maximum allowed length is 1500 bytes",
    saveAsDraft: "Save as Draft",
    sendImmediately: "Send Immediately",
    FailedToSend: "Failed to Send",
    SentSuccessfully: "Sent Successfully",
    sending: "Sending",
    draft: "Draft",
    advancedConfiguration: "Advanced Configuration",
    notConnect: 'No connection yet'
  },
  webssh: {
    connect: 'Connecting',
    newWindow: 'Open in a new window',
    disconnect: 'Disconnecting',
    tunnel: 'Tunnel building',
    disconnectLoading: 'Disconnecting',
    'DeviceMQTToffline': 'Device MQTT offline',
    'Failed to obtain terminal address': 'Failed to obtain terminal address',
    tunnelErr: 'Tunnel connection failed, please check network or device status',
    Unexpecteddisconnection: 'Unexpected disconnection',
    SelectRoute: "Select Route",
    DEFAULT: "Default",
    ChinaMobile: "China Mobile",
    ChinaTelecom: "China Telecom"
  }
};
